import axios from 'axios';

import { ResetPasswordPageState } from 'pages/ResetPassword/types';
import { getCsrfToken } from 'utils/auth';
import { API_ENDPOINTS } from 'utils/constants';

export const resetPasswordRequest = ({
  token,
  password,
  locale
}: {
  token: string;
  password: ResetPasswordPageState['password'];
  locale: string;
}): Promise<{ location?: string; action?: string }> =>
  axios({
    method: 'put',
    url: API_ENDPOINTS.RESET_PASSWORD,
    data: {
      token,
      password,
      locale,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      _csrf_token: getCsrfToken()
    },
    headers: {
      accept: 'application/json'
    }
  }).then((response) => response.data);
